import { reportError } from '@gef-ui/error-handler/actions';
import { LogLevel, LogType, Logger } from '@gef-ui/logging';
import { getAccessToken } from '@gef-ui/redux-common/selectors/appContext';
import { callActionsWithArgs } from '../../../middleware/utils';
import { withAccess, withAccessToken } from '../../access/facade';
import { dissocOnError, getOnError } from '../../utils';
/**
 * REST API facade decorator factory, expects to get function to obtain accessToken and possible authHeaderName property
 *
 *
 * @documented
 * @category facadeDecoratorFactory
 *
 * @param obtainAccessTokenFunc
 * @param withAccessOptions
 * @returns function
 */ const withRefreshTokenFacadeFactory = (obtainAccessTokenFunc, withAccessOptions)=>{
    return (wrapped)=>(args = {})=>async (dispatch, getState)=>{
                const accessToken = getAccessToken(getState());
                if (!accessToken) {
                    await dispatch(obtainAccessTokenFunc(args.accessTokenPayload, args.beforeLogout));
                }
                try {
                    return await dispatch(withAccessToken(wrapped)({
                        ...dissocOnError(args),
                        notReportError: true,
                        ...withAccessOptions
                    }));
                } catch (err) {
                    Logger.info({
                        middleware: 'Refresh token facade',
                        message: 'Error while calling be',
                        err
                    }, LogLevel.INFO, LogType.INFO);
                    // todo nevim jak to vyresit lepe
                    if (err.status === 401 && !err?.parsedContent?.type?.includes('CannotDelegateException')) {
                        await dispatch(obtainAccessTokenFunc(args.accessTokenPayload, args.beforeLogout || err.originalAction?.beforeLogout));
                        return dispatch(withAccess(wrapped)({
                            ...args,
                            ...withAccessOptions
                        }));
                    } else {
                        if (!args.notReportError) {
                            dispatch(reportError(err));
                        }
                        callActionsWithArgs(dispatch, args.runInBatch, getOnError(args), [
                            {
                                failure: err
                            }
                        ]);
                        return Promise.reject(err);
                    }
                }
            };
};
export default withRefreshTokenFacadeFactory;
